import { showToast } from "@cerebruminc/cerebellum";

/**
 * method to show error toast message
 * @param text message string
 */
export const showError = (text: string) => {
	showToast({
		id: `error-toast-${Date.now()}`,
		message: text,
		tone: "negative",
	});
};
